import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  HOME_CREATE_PRICE_SUBSCRIPTION_BEGIN,
  HOME_CREATE_PRICE_SUBSCRIPTION_SUCCESS,
  HOME_CREATE_PRICE_SUBSCRIPTION_FAILURE,
  HOME_CREATE_PRICE_SUBSCRIPTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function createPriceSubscription(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: HOME_CREATE_PRICE_SUBSCRIPTION_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${config.apiRootUrl}/subscriptions/create-price-subscription`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_CREATE_PRICE_SUBSCRIPTION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_CREATE_PRICE_SUBSCRIPTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreatePriceSubscriptionError() {
  return {
    type: HOME_CREATE_PRICE_SUBSCRIPTION_DISMISS_ERROR,
  };
}

export function useCreatePriceSubscription() {
  const dispatch = useDispatch();

  const { createPriceSubscriptionPending, createPriceSubscriptionError } =
    useSelector(
      (state) => ({
        createPriceSubscriptionPending:
          state.home.createPriceSubscriptionPending,
        createPriceSubscriptionError: state.home.createPriceSubscriptionError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(createPriceSubscription(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCreatePriceSubscriptionError());
  }, [dispatch]);

  return {
    createPriceSubscription: boundAction,
    createPriceSubscriptionPending,
    createPriceSubscriptionError,
    dismissCreatePriceSubscriptionError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CREATE_PRICE_SUBSCRIPTION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createPriceSubscriptionPending: true,
        createPriceSubscriptionError: null,
      };

    case HOME_CREATE_PRICE_SUBSCRIPTION_SUCCESS:
      // The request is success
      return {
        ...state,
        createPriceSubscriptionPending: false,
        createPriceSubscriptionError: null,
      };

    case HOME_CREATE_PRICE_SUBSCRIPTION_FAILURE:
      // The request is failed
      return {
        ...state,
        createPriceSubscriptionPending: false,
        createPriceSubscriptionError: action.data.error,
      };

    case HOME_CREATE_PRICE_SUBSCRIPTION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createPriceSubscriptionError: null,
      };

    default:
      return state;
  }
}
